import React from "react";
import { FaCalendarAlt, FaBuilding } from "react-icons/fa";

const projects = [
  {
    title: "Final Project - Mobile and Desktop Application",
    description:
      "Automatic detection of road anomalies and traffic monitoring using AI and computer vision.",
    date: "Apr. 2024 - Jul. 2024",
    organization: "ISMAGI Rabat",
  },
  {
    title: "HR Management System - Final Project",
    description:
      "Design and development of a Human Resources Management System using Laravel 9 framework.",
    date: "Jun. 2023",
    organization: "ISMAGI Rabat",
  },
  {
    title: "AI Messenger Chatbot",
    description:
      "Design and deployment of a Messenger Chatbot using IBM Watson.",
    date: "Apr. 2023",
    organization: "ISMAGI Rabat",
  },
  {
    title: "Absence Management System",
    description:
      "Study, design, and development of a system using facial recognition (Python/OpenCV).",
    date: "Mar. 2023",
    organization: "ISMAGI Rabat",
  },
  {
    title: "Final DUT Project - Online Store",
    description:
      "Design and development of an online store using Symfony 4 framework.",
    date: "Apr. 2019 - Jun. 2019",
    organization: "Higher School of Technology of Meknes (ESTM)",
  },
  {
    title: "Maintenance Intervention Management",
    description:
      "Design and development of a web application for managing IT maintenance interventions.",
    date: "Apr. 2019 - Jun. 2019",
    organization:
      "Ministry of Higher Education, Scientific Research, and Innovation - Morocco",
  },
  {
    title: "BI-Market - E-Commerce Website",
    description:
      "Design and development of an e-commerce website using Symfony 4 framework.",
    date: "Jan. 2019 - Apr. 2019",
    organization: "Higher School of Technology of Meknes (ESTM)",
  },
  {
    title: "Internship Project - InfoMarket.ma",
    description: "Development of an online store.",
    date: "",
    organization: "InfoMarket.ma",
  },
];

const Projects = () => {
  return (
    <section id="Projects" className="bg-gray-100 py-16 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800">Projects</h1>
          <p className="text-lg text-orange-500 mt-2">My Work Portfolio</p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 transform hover:scale-105 transition-transform duration-300 hover:shadow-2xl"
            >
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                {project.title}
              </h2>
              <p className="text-gray-600 mb-4">{project.description}</p>
              <div className="flex items-center text-sm text-gray-500 gap-2 mb-2">
                <FaCalendarAlt className="text-orange-500" />
                <span>{project.date || "N/A"}</span>
              </div>
              <div className="flex items-center text-sm text-gray-500 gap-2">
                <FaBuilding className="text-orange-500" />
                <span>{project.organization}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
